import { Component } from '@angular/core';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
import { ListaLineasComponent } from './lista-lineas/lista-lineas.component';

@Component({
  selector: 'app-linea-adquirente',
  templateUrl: './linea-adquirente.component.html',
  styleUrls: ['./linea-adquirente.component.scss'],
  providers:[ListaLineasComponent,MessagesTitles, MessagesStatus]
})
export class LineaAdquirenteComponent {
  abrirDetalleLinea: boolean = false;
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  constructor(private loginService: LoginService,
    private linea:ListaLineasComponent,
    ) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
  crearNuevaLinea() {
    this.linea.lineaAdquirente = null;
    this.abrirDetalleLinea = true;
  }
  refresh(){
    this.linea.updateChart = true;
    this.linea.obtenerListaLineasAdquirente();
  }
  cerrarPopUp() {
    this.abrirDetalleLinea = false;
  }
  exportarAExcel() {
   this.linea.exportarAExcel()
  }
}
